"use strict";

var _regeneratorRuntime = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var metadata_1 = require("./metadata");
/**
 * A class that represents a generic method of adding authentication-related
 * metadata on a per-request basis.
 */


var CallCredentials =
/*#__PURE__*/
function () {
  function CallCredentials() {
    _classCallCheck(this, CallCredentials);
  }

  _createClass(CallCredentials, null, [{
    key: "createFromMetadataGenerator",

    /**
     * Creates a new CallCredentials object from a given function that generates
     * Metadata objects.
     * @param metadataGenerator A function that accepts a set of options, and
     * generates a Metadata object based on these options, which is passed back
     * to the caller via a supplied (err, metadata) callback.
     */
    value: function createFromMetadataGenerator(metadataGenerator) {
      return new SingleCallCredentials(metadataGenerator);
    }
  }, {
    key: "createEmpty",
    value: function createEmpty() {
      return new EmptyCallCredentials();
    }
  }]);

  return CallCredentials;
}();

exports.CallCredentials = CallCredentials;

var ComposedCallCredentials =
/*#__PURE__*/
function (_CallCredentials) {
  _inherits(ComposedCallCredentials, _CallCredentials);

  function ComposedCallCredentials(creds) {
    var _this;

    _classCallCheck(this, ComposedCallCredentials);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ComposedCallCredentials).call(this));
    _this.creds = creds;
    return _this;
  }

  _createClass(ComposedCallCredentials, [{
    key: "generateMetadata",
    value: function generateMetadata(options) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var base, generated, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, gen;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                base = new metadata_1.Metadata();
                _context.next = 3;
                return Promise.all(lodash_1.map(this.creds, function (cred) {
                  return cred.generateMetadata(options);
                }));

              case 3:
                generated = _context.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;

                for (_iterator = generated[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  gen = _step.value;
                  base.merge(gen);
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 15:
                _context.prev = 15;
                _context.prev = 16;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 18:
                _context.prev = 18;

                if (!_didIteratorError) {
                  _context.next = 21;
                  break;
                }

                throw _iteratorError;

              case 21:
                return _context.finish(18);

              case 22:
                return _context.finish(15);

              case 23:
                return _context.abrupt("return", base);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));
    }
  }, {
    key: "compose",
    value: function compose(other) {
      return new ComposedCallCredentials(this.creds.concat([other]));
    }
  }]);

  return ComposedCallCredentials;
}(CallCredentials);

var SingleCallCredentials =
/*#__PURE__*/
function (_CallCredentials2) {
  _inherits(SingleCallCredentials, _CallCredentials2);

  function SingleCallCredentials(metadataGenerator) {
    var _this2;

    _classCallCheck(this, SingleCallCredentials);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SingleCallCredentials).call(this));
    _this2.metadataGenerator = metadataGenerator;
    return _this2;
  }

  _createClass(SingleCallCredentials, [{
    key: "generateMetadata",
    value: function generateMetadata(options) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.metadataGenerator(options, function (err, metadata) {
          if (metadata !== undefined) {
            resolve(metadata);
          } else {
            reject(err);
          }
        });
      });
    }
  }, {
    key: "compose",
    value: function compose(other) {
      return new ComposedCallCredentials([this, other]);
    }
  }]);

  return SingleCallCredentials;
}(CallCredentials);

var EmptyCallCredentials =
/*#__PURE__*/
function (_CallCredentials3) {
  _inherits(EmptyCallCredentials, _CallCredentials3);

  function EmptyCallCredentials() {
    _classCallCheck(this, EmptyCallCredentials);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmptyCallCredentials).apply(this, arguments));
  }

  _createClass(EmptyCallCredentials, [{
    key: "generateMetadata",
    value: function generateMetadata(options) {
      return Promise.resolve(new metadata_1.Metadata());
    }
  }, {
    key: "compose",
    value: function compose(other) {
      return other;
    }
  }]);

  return EmptyCallCredentials;
}(CallCredentials);